(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guf-newsletter-popup"]) return;
  try {
    
  if (!customElements.get('guf-signup-popup')) {
    customElements.define('guf-signup-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.teaser = this.querySelector('[data-signup-teaser]');
        this.result = this.querySelector('[data-signup-result]');
        if (!this.dialog?.showModal || !this.form || !this.result) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.storageKey = `guf.signup.${this.dataset.campaign || 'welcome'}`;
        this.pendingKey = `${this.storageKey}.pending`;
        this.state = this.result.dataset.state;
        this.designMode = this.dataset.designMode === 'true';
        this.mobile = window.matchMedia('(max-width: 760px)');
        this.visitorSubscribed = this.dataset.subscribed === 'true' || this.readStore('subscribed') === true;
        this.teaserDismissed = this.readStore('teaserUntil') > Date.now();
        this.form.querySelector('[data-signup-code]')?.addEventListener('click', event => event.target.select(), options);
        this.querySelector('[data-signup-open]')?.addEventListener('click', event => this.open(event.currentTarget), options);
        this.querySelector('[data-signup-close]')?.addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-signup-hide]')?.addEventListener('click', () => {
          this.teaserDismissed = true;
          this.teaser.hidden = true;
          this.writeStore('teaserUntil', this.dismissUntil());
        }, options);
        this.querySelector('[data-signup-copy]')?.addEventListener('click', () => this.copyCode(), options);
        this.dialog.addEventListener('close', () => this.closed(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        this.form.addEventListener('submit', () => {
          if (!this.form.checkValidity()) return;
          try { sessionStorage.setItem(this.pendingKey, String(Date.now())); } catch (_) {}
        }, options);
        document.addEventListener('shopify:section:select', event => {
          if (event.target.contains(this)) this.showEditorPreview();
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.target.contains(this) && this.dialog.open) this.dialog.close();
        }, options);
        if (this.designMode) { this.showEditorPreview(); return; }
        let pending = 0;
        try { pending = Number(sessionStorage.getItem(this.pendingKey)); } catch (_) {}
        const fromThisPopup = location.hash === `#${this.form.id}` || (pending > 0 && Date.now() - pending < 900000);
        if (this.state === 'success') {
          this.showSuccess();
          if (fromThisPopup) {
            this.visitorSubscribed = true;
            this.writeStore('subscribed', true);
            try { sessionStorage.removeItem(this.pendingKey); } catch (_) {}
            this.open();
          }
          return;
        }
        if (this.state === 'error' && fromThisPopup) {
          this.open();
          this.querySelector('[data-signup-error]')?.focus({ preventScroll: true });
          return;
        }
        if (!this.isEnabled() || this.visitorSubscribed) return;
        this.updateTeaser();
        if (this.readStore('dismissUntil') > Date.now()) return;
        if (this.mobile.matches && this.dataset.mobileAuto !== 'true') return;
        this.autoReady = false;
        this.timer = setTimeout(() => { this.autoReady = true; this.tryAutoOpen(); }, Math.max(0, Number(this.dataset.delay) || 0) * 1000);
        document.addEventListener('visibilitychange', () => this.tryAutoOpen(), options);
        document.addEventListener('close', () => this.tryAutoOpen(), { ...options, capture: true });
        document.addEventListener('focusout', () => { clearTimeout(this.focusTimer); this.focusTimer = setTimeout(() => this.tryAutoOpen(), 150); }, options);
      }
      readStore(key) {
        try { return JSON.parse(localStorage.getItem(`${this.storageKey}.${key}`)); } catch (_) { return null; }
      }
      writeStore(key, value) {
        try { localStorage.setItem(`${this.storageKey}.${key}`, JSON.stringify(value)); } catch (_) {}
      }
      dismissUntil() { return Date.now() + Math.max(1, Number(this.dataset.dismissDays) || 7) * 86400000; }
      isEnabled() { return !this.mobile.matches || this.dataset.mobile === 'true'; }
      updateTeaser() {
        this.teaser.hidden = this.dataset.teaser !== 'true' || this.visitorSubscribed || this.teaserDismissed || !this.isEnabled() || this.dialog.open;
      }
      tryAutoOpen() {
        if (!this.autoReady || this.autoDone || !this.isConnected || document.hidden || this.visitorSubscribed || !this.isEnabled()) return;
        if (this.readStore('dismissUntil') > Date.now() || (this.mobile.matches && this.dataset.mobileAuto !== 'true')) return;
        if (document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]') || document.body.classList.contains('modal-open')) return;
        if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return;
        this.autoDone = true;
        this.open();
      }
      open(trigger) {
        if (this.dialog.open) return;
        this.autoDone = true;
        clearTimeout(this.timer);
        this.returnFocus = trigger || document.activeElement;
        this.teaser.hidden = true;
        this.dialog.showModal();
        document.body.classList.add('modal-open');
        this.querySelector('[data-signup-close]')?.focus({ preventScroll: true });
      }
      closed() {
        if (!this.designMode) this.writeStore('dismissUntil', this.dismissUntil());
        this.updateTeaser();
        if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
        if (this.returnFocus?.isConnected && this.returnFocus !== document.body && this.returnFocus.getClientRects().length) this.returnFocus.focus({ preventScroll: true });
      }
      showSuccess() {
        this.querySelector('[data-signup-entry]').hidden = true;
        this.querySelector('[data-signup-success]').hidden = false;
        this.dialog.classList.add('is-success');
        this.dialog.setAttribute('aria-labelledby', this.querySelector('.guf-signup__success-title').id);
      }
      showEditorPreview() {
        if (this.dataset.editorView === 'closed') { if (this.dialog.open) this.dialog.close(); this.updateTeaser(); return; }
        if (this.dataset.editorView === 'success') this.showSuccess();
        this.open();
      }
      async copyCode() {
        const input = this.querySelector('[data-signup-code]');
        const status = this.querySelector('[data-signup-copy-status]');
        try {
          await navigator.clipboard.writeText(input.value);
          status.textContent = status.dataset.copied;
        } catch (_) {
          input.focus();
          input.select();
          status.textContent = status.dataset.copyFailed;
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.focusTimer);
        this.controller?.abort();
        this.controller = null;
        if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guf-vfx-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('guf-vfx-motion')) {
    customElements.define('guf-vfx-motion', class extends HTMLElement {
      connectedCallback() {
        this.root = document.getElementById('MainContent');
        if (!this.root) return;
        if (this.root._gufMotionController && this.root._gufMotionController !== this) {
          this.inert = true;
          return;
        }
        this.root._gufMotionController = this;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.restart = () => this.initialize();
        this.reduced.addEventListener('change', this.restart);
        this.mobile.addEventListener('change', this.restart);
        document.addEventListener('shopify:section:load', this.restart);
        this.initialFrame = requestAnimationFrame(this.restart);
      }

      initialize() {
        this.cleanup();
        if (this.dataset.enabled !== 'true' || this.reduced.matches || document.body.classList.contains('motion-off')) return;
        if (this.mobile.matches && this.dataset.mobile !== 'true') return;
        if (this.dataset.editor === 'true' && this.dataset.editorPreview !== 'true') return;
        if (!('IntersectionObserver' in window)) return;
        this.abort = new AbortController();
        this.nodes = [];
        this.scenes = [];
        this.drifts = [];
        this.visibleDrifts = new Set();
        this.root.style.setProperty('--gvm-duration', `${Number(this.dataset.duration) || 900}ms`);
        this.root.style.setProperty('--gvm-distance', `${Number(this.dataset.distance) || 56}px`);
        this.root.style.setProperty('--gvm-accent', this.dataset.accent);
        this.root.classList.add('gvm-active');
        const definitions = [
          ['text', '.section-heading > div,.section-heading > h2,.page-heading,.article-header,.product-hero-copy,.gs-product-info-inner > .eyebrow,.gs-product-title,.gs-product-tagline,.gvl-story-heading > div,.workflow-section .section-heading,.comparison-section .section-heading,.includes-section > div > .eyebrow,.includes-section > div > h2,.faq-section > div:first-child,.spotlight-copy,.editorial-statement > div,[class^="ai-yv-"][class$="__text"]'],
          ['media', '.hero-media,.spotlight-media,.demo-media,.product-stage,.gs-product-preview,.gvl-feature-video,.includes-cover-frame,.configurable-comparison,.article-hero-image,.article-card-image,[class^="ai-yv-"][class$="__media"]'],
          ['card', '.product-grid > *,.collection-grid > *,.blog-grid > *,.search-results-grid > *,.gvl-story-card,.workflow-grid > li,.includes-list > li,.faq-list > details,.gg-card']
        ];
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) this.reveal(entry.target);
            else if (this.dataset.replay === 'true' && entry.boundingClientRect.top > window.innerHeight) {
              entry.target.classList.add('gvm-wait');
              entry.target.classList.remove('gvm-entered');
            }
          });
        }, { rootMargin:'0px 0px -6% 0px', threshold:0 });
        definitions.forEach(([type, selector]) => {
          this.root.querySelectorAll(selector).forEach(node => {
            if (node.closest('guf-vfx-motion') || this.nodes.includes(node)) return;
            const siblings = Array.from(node.parentElement.children).filter(item => item.matches(selector));
            const delay = Math.min(Math.max(siblings.indexOf(node), 0), 3) * 85;
            node.classList.add('gvm-reveal', `gvm-${type}`);
            node.style.setProperty('--gvm-delay', `${delay}ms`);
            this.nodes.push(node);
            if (node.getBoundingClientRect().top > window.innerHeight * .92) node.classList.add('gvm-wait');
            else node.classList.add('gvm-entered');
            this.observer.observe(node);
          });
        });
        this.root.querySelectorAll('.gvl-story:not(.gvl-story--light),.workflow-section,.spotlight.section,.comparison-section,.includes-section,.faq-section,.page-section').forEach(node => {
          node.classList.add('gvm-scene');
          this.scenes.push(node);
          this.observer.observe(node);
        });
        this.root.addEventListener('focusin', event => {
          const item = event.target.closest('.gvm-reveal');
          if (item) this.reveal(item);
        }, { signal:this.abort.signal });
        if (this.dataset.parallax === 'true' && !this.mobile.matches) {
          this.drifts = Array.from(this.root.querySelectorAll('.includes-cover,.product-stage img,.gs-product-cover img'));
          this.drifts.forEach(node => node.classList.add('gvm-drift'));
          this.driftObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) this.visibleDrifts.add(entry.target);
              else this.visibleDrifts.delete(entry.target);
            });
            this.scheduleDrift();
          }, { rootMargin:'100px 0px' });
          this.drifts.forEach(node => this.driftObserver.observe(node));
          window.addEventListener('scroll', () => this.scheduleDrift(), { passive:true, signal:this.abort.signal });
          window.addEventListener('resize', () => this.scheduleDrift(), { passive:true, signal:this.abort.signal });
        }
      }

      reveal(node) {
        node.classList.remove('gvm-wait');
        node.classList.add('gvm-entered');
        if (this.dataset.replay !== 'true') this.observer.unobserve(node);
      }

      scheduleDrift() {
        if (this.frame || !this.visibleDrifts.size || document.hidden) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.visibleDrifts.forEach(node => {
            const rect = node.parentElement.getBoundingClientRect();
            const progress = Math.max(-1, Math.min(1, (window.innerHeight / 2 - rect.top - rect.height / 2) / window.innerHeight));
            node.style.setProperty('--gvm-shift', `${(progress * 28).toFixed(2)}px`);
            node.style.setProperty('--gvm-turn', `${(progress * 2).toFixed(2)}deg`);
          });
        });
      }

      cleanup() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.driftObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        (this.nodes || []).forEach(node => {
          node.classList.remove('gvm-reveal','gvm-text','gvm-media','gvm-card','gvm-wait','gvm-entered');
          node.style.removeProperty('--gvm-delay');
        });
        (this.scenes || []).forEach(node => node.classList.remove('gvm-scene','gvm-entered','gvm-wait'));
        (this.drifts || []).forEach(node => {
          node.classList.remove('gvm-drift');
          node.style.removeProperty('--gvm-shift');
          node.style.removeProperty('--gvm-turn');
        });
        this.root?.classList.remove('gvm-active');
        ['--gvm-duration','--gvm-distance','--gvm-accent'].forEach(property => this.root?.style.removeProperty(property));
      }

      disconnectedCallback() {
        if (this.inert) return;
        cancelAnimationFrame(this.initialFrame);
        this.cleanup();
        this.reduced?.removeEventListener('change', this.restart);
        this.mobile?.removeEventListener('change', this.restart);
        document.removeEventListener('shopify:section:load', this.restart);
        if (this.root?._gufMotionController === this) this.root._gufMotionController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
